import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-409a4e42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DefaultLayout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_new_header = _resolveComponent("new-header")!
  const _component_impersonate_panel = _resolveComponent("impersonate-panel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sidebar, {
      "is-opened": _ctx.state.is_opened,
      onToggle: _ctx.toggleSidebar
    }, null, 8, ["is-opened", "onToggle"]),
    _createElementVNode("div", {
      class: _normalizeClass(['DefaultLayout__view', { wide: !_ctx.state.is_opened }])
    }, [
      _createVNode(_component_new_header, { "without-sectors": "" }),
      (_ctx.impersonate_state.is_active)
        ? (_openBlock(), _createBlock(_component_impersonate_panel, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      _createVNode(_component_router_link, {
        to: "/navigation",
        class: "mobileButton"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _createTextVNode(" Навигация ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 2)
  ]))
}